import { ESPConnection } from "../espConnection";
var TopologyService = /** @class */ (function () {
    function TopologyService(optsConnection) {
        this._connection = new ESPConnection(optsConnection, "WsTopology", "1.25");
    }
    TopologyService.prototype.connectionOptions = function () {
        return this._connection.opts();
    };
    TopologyService.prototype.protocol = function () {
        var parts = this._connection.opts().baseUrl.split("//");
        return parts[0];
    };
    TopologyService.prototype.ip = function () {
        var parts = this._connection.opts().baseUrl.split("//");
        var parts2 = parts[1].split(":");
        return parts2[0];
    };
    TopologyService.prototype.TpLogicalClusterQuery = function (request) {
        if (request === void 0) { request = {}; }
        return this._connection.send("TpLogicalClusterQuery", request);
    };
    TopologyService.prototype.DefaultTpLogicalClusterQuery = function (request) {
        if (request === void 0) { request = {}; }
        return this.TpLogicalClusterQuery(request).then(function (response) {
            if (response.default) {
                return response.default;
            }
            var firstHThor;
            var first;
            response.TpLogicalClusters.TpLogicalCluster.some(function (item, idx) {
                if (idx === 0) {
                    first = item;
                }
                if (item.Type === "hthor") {
                    firstHThor = item;
                    return true;
                }
                return false;
            });
            return firstHThor || first;
        });
    };
    TopologyService.prototype.TpServiceQuery = function (request) {
        return this._connection.send("TpServiceQuery", request);
    };
    TopologyService.prototype.TpTargetClusterQuery = function (request) {
        return this._connection.send("TpTargetClusterQuery", request);
    };
    return TopologyService;
}());
export { TopologyService };
//# sourceMappingURL=wsTopology.js.map